import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Input, Select, DatePicker, Modal, Tag, Skeleton, Pagination, Tooltip, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FaFileAlt, FaAnchor, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import FrmAddContract from '../func/FrmAddContract';
import FrmUpdateContract from '../func/FrmUpdateContract';
import { saveAs } from 'file-saver';
import DeleteConfirmationModal from '../func/DeleteConfirmationModal';

import TabCpn from '../func/TabCpn';
import moment from 'moment';
import dayjs from 'dayjs';
//import ModalContext from '../../ModalContext'; // Make sure the path is correct
import './../../../css/BadgeAnt.css'

const { Option } = Select;

const CustomModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};


const CustomModalMenu = ({ isOpen, onClose, children, hasUnsavedChanges }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-menu-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};



const MenuTinChap = () => {
    const [data, setData] = useState([]);
    const [isOpenTabMenu, setOpenTabMenu] = useState(false);
    const [isAddContract, setIsAddContract] = useState(false);
    const [isDeleteContract, setIsDeleteContract] = useState(false);
    const [isUpdateContract, setIsUpdateContract] = useState(false);
    const [modalContent, setModalContent] = useState({ tab: "1", id: null }); // New state to hold tab and id
    const [loading, setLoading] = useState(true); // Loading state for the skeleton
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [txtMaHD, setTxtMaHD] = useState('');
    const [txtTenKH, setTxtTenKH] = useState('');
    const [txtCMND, setTxtCMND] = useState('');
    const [txtPhone, setTxtPhone] = useState('');
    const [pageSize, setPageSize] = useState(10); // Số dòng hiển thị mặc định
    const [currentPage, setCurrentPage] = useState(1); // Trang hiện tại
    const [selectedCode, setSelectedCode] = useState("0");
    
    
    /// INFO

    const [total_interest_predict, setTotal_interest_predict] = useState(0);
    const [total_debit_money, setTotal_debit_money] = useState(0);
    const [total_interest_received, setTotal_interest_received] = useState(0);
    const [total_loan, setTotal_loan] = useState(0);
    const [totalCapital, setTotalCapital] = useState(0);

    const handleSelectChange = (value) => {
        setSelectedCode(value);
    };

    useEffect(() => {
   //     console.log("Selected code: " + selectedCode)
        fetchData();
    }, [selectedCode])


    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };




    const handleOk = async (id) => {

        if (id === 0) return;

        const token = localStorage.getItem('token'); // Lấy token từ local storage
        const response = await fetch(`${process.env.REACT_APP_API_DB_URL}/delete-loan/${id}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`, // Gửi token trong header
            },
        });

        if (response.ok) {
            setModalContent({ tab: 0, id: 0 });
            setIsDeleteContract(false);
            message.success("Xóa hợp đồng thành công")
            fetchData();
        } else {
            message.error(`Xóa hợp đồng ${id} thất bại`)
        }
    };

    const handleCancel = () => {
        setIsDeleteContract(false);
    };


    const fetchData = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (fromDate) {
            params.append('fromDate', moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        }
        if (toDate) {
            params.append('toDate', moment(toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        }

        if (txtMaHD.trim()) {
            params.append('loanId', txtMaHD.trim());
        }

        if (txtTenKH.trim()) {
            params.append('name', txtTenKH.trim());
        }

        if (txtCMND.trim()) {
            params.append('numberCard', txtCMND.trim());
        }

        if (txtPhone.trim()) {
            params.append('phone', txtPhone.trim());
        }

        params.append('code', Number(selectedCode));


        // fetch(`${process.env.REACT_APP_API_DB_URL}/list-loan-credit?${params.toString()}`)
        //     .then(response => response.json())
        //     .then(d => {
        //         setData(d);
        //         setLoading(false);
        //     })
        //     .catch(error => {
        //         console.error('Error fetching data:', error);
        //         setLoading(false);
        //     });
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/list-loan-credit?${params.toString()}`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                // Kiểm tra kiểu dữ liệu
                if (Array.isArray(d) || typeof d === 'object') {
                    setData(d);
                } else {
                    console.warn('Dữ liệu không hợp lệ:', d);
                    setData([]); // Thiết lập thành mảng rỗng nếu dữ liệu không hợp lệ
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
                setData([]); // Thiết lập thành mảng rỗng trong trường hợp có lỗi
                setLoading(false);
            });
    };


    const fetchDataInfo = () => {
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/data-dashboard-credit`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                setTotal_interest_predict(d.total_interest_predict);
                setTotal_debit_money(d.total_debit_money);
                setTotal_interest_received(d.total_interest_received);
                setTotal_loan(d.total_loan);
                setTotalCapital(d.total_capital);
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
            });
    }

    useEffect(() => {
        fetchDataInfo();
    }, []);


    const handleOpenTabMenu = (tab, id) => {
        setModalContent({ tab, id });
        setOpenTabMenu(true);
    };

    const handleDeleteMenu = (tab, id) => {
        setModalContent({ tab, id });
        setIsDeleteContract(true);
    };

    const handleAddContract = () => {
        setIsAddContract(true);
    };


    const handleUpdateContract = (id) => {
        setModalContent((prevState) => ({
            ...prevState,  // Keep the existing tab value
            id: id,        // Update only the id
        }));
        setIsUpdateContract(true);
    };

    const columns = [
        { title: '#', dataIndex: 'index', key: 'index', render: (_, __, index) => index + 1 },
        {
            title: 'Mã HD',
            dataIndex: 'LOAN_ID',
            key: 'LOAN_ID',
            render: (text, record) => (
                <a
                    onClick={() => handleUpdateContract(record.LOAN_ID)}
                    style={{
                        color: '#007bff', // Bootstrap primary color or use another
                        fontWeight: 'bold', // Make it bold
                        textDecoration: 'underline', // Add underline
                        cursor: 'pointer' // Make it look like it's clickable
                    }}
                >
                    {text}
                </a>
            )
        },

        { title: 'Khách hàng', dataIndex: 'NAME', key: 'NAME' },
        { title: 'VNĐ', dataIndex: 'TOTAL_MONEY', key: 'TOTAL_MONEY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Ngày vay', dataIndex: 'FROM_DATE', key: 'FROM_DATE', render: (value) => moment(value).format('DD/MM/YYYY') },
        { title: 'Lãi đã đóng', dataIndex: 'INTEREST_MONEY_RECEIVED', key: 'INTEREST_MONEY_RECEIVED', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Nợ cũ', dataIndex: 'DEBIT_MONEY', key: 'DEBIT_MONEY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Lãi đến hôm nay', dataIndex: 'INTEREST_TODAY', key: 'INTEREST_TODAY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Ngày phải đóng lãi', dataIndex: 'STR_NEXT_DATE', key: 'STR_NEXT_DATE' },
        {
            title: 'Tình trạng', dataIndex: 'STR_STATUS', key: 'STR_STATUS', render: (status) => (
                <Tag color={status === 'Nợ lãi' ? '#fcba03' : (status === 'Quá hạn' ? '#F4516C' : '#108ee9')}>{status}</Tag>
            )
        },
        {
            title: 'Chức năng',
            key: 'actions',
            render: (_, record) => (
                <>
                    <div>
                        <Tooltip title="Đóng tiền">
                            <Button
                                className="icon-button"
                                type="link"
                                style={{ fontSize: '20px' }}
                                onClick={() => handleOpenTabMenu("1", record.LOAN_ID)}
                                icon={<FaFileAlt style={{ color: '#fcba03' }} />}
                            />
                        </Tooltip>


                        <Tooltip title="Đóng hợp đồng">
                            <Button
                                className="icon-button"
                                type="link"
                                style={{ fontSize: '20px' }}
                                onClick={() => handleOpenTabMenu("5", record.LOAN_ID)}
                                icon={<FaAnchor style={{ color: 'green' }} />}
                            />
                        </Tooltip>

                        <Tooltip title="Xóa hợp đồng">
                            <Button
                                className="icon-button"
                                type="link"
                                onClick={() => handleDeleteMenu("7", record.LOAN_ID)}
                                style={{ fontSize: '20px' }}
                                icon={<FaTimes style={{ color: 'red' }} />}
                            />
                        </Tooltip>
                    </div>
                </>
            )

        },
    ];

    const summaryData = data.length > 0 ? data[data.length - 1] : { TotalMoney: 0, InterestMoneyReceived: 0, InterestToDay: 0 };

    const handleCloseModal = () => {
        setIsAddContract(false)
        fetchData(); // Call fetchData when the modal is closed
    };

    const handleCloseUpdate = () => {
        setIsUpdateContract(false)
        fetchData(); // Call fetchData when the modal is closed
    };


    const handleSearch = () => {
        fetchData();
    }


    const handleDownload = () => {
        
        const token = localStorage.getItem('token'); // Lấy token từ localStorage
        
        fetch(`${process.env.REACT_APP_API_DB_URL}/download-excel-credit`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
        .then(response => {
            if (response.ok) {
                return response.blob(); // Chuyển đổi dữ liệu thành blob
            }
            throw new Error('Network response was not ok.');
        })
        .then(blob => {
            saveAs(blob, 'VayLai - Báo cáo sổ quỹ tiền mặt.xlsx'); // Sử dụng file-saver để tải file về
        })
        .catch(error => {
            console.error('Error downloading the file:', error);
        });
    };

    return (
        <div className="md:p-1">
            <h1 className="text-xl md:text-2xl font-bold mb-4">Hợp đồng Tín Chấp</h1>
            <div className="flex flex-wrap justify-between gap-4 mb-4">
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">QUỸ TIỀN MẶT</p>
                    <p className="text-xl md:text-2xl font-bold">{totalCapital.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">TIỀN CHO VAY</p>
                    <p className="text-xl md:text-2xl font-bold">{total_loan.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">TIỀN NỢ</p>
                    <p className="text-xl md:text-2xl font-bold">{total_debit_money.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">LÃI DỰ KIẾN</p>
                    <p className="text-xl md:text-2xl font-bold">{total_interest_predict.toLocaleString('vi-VN')}</p>
                </div>
                <div className="bg-gray-200 p-4 text-center flex-1 min-w-[150px] sm:min-w-[200px]">
                    <p className="text-sm">LÃI ĐÃ THU</p>
                    <p className="text-xl md:text-2xl font-bold">{total_interest_received.toLocaleString('vi-VN')}</p>
                </div>
            </div>

            <div className="flex flex-wrap mb-4">
                <Button type="primary" className="mr-2 mb-2" onClick={handleAddContract}>Thêm mới</Button>
                <Button type="default" className="mr-2 mb-2" onClick={handleDownload}>Xuất Excel</Button>
            </div>

            <div className="flex flex-wrap mb-4">
                <Input placeholder="Tìm kiếm mã HĐ" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtMaHD} onChange={(e) => setTxtMaHD(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm tên KH" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtTenKH} onChange={(e) => setTxtTenKH(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm CMND" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtCMND} onChange={(e) => setTxtCMND(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm số điện thoại" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtPhone} onChange={(e) => setTxtPhone(e.target.value)} onKeyDown={handleKeyDown} />
                <DatePicker placeholder="Từ ngày" value={fromDate ? dayjs(fromDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                    format={'DD/MM/YYYY'}
                    onChange={(date, dateString) => {
                        setFromDate(dateString); // Update fromDate when a new date is picked
                    }} className="mr-2 mb-2 flex-1 min-w-[150px]" />
                <DatePicker placeholder="Đến ngày" value={toDate ? dayjs(toDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                    format={'DD/MM/YYYY'}
                    onChange={(date, dateString) => {
                        setToDate(dateString); // Update fromDate when a new date is picked
                    }} className="mr-2 mb-2 flex-1 min-w-[150px]" />



                <Select defaultValue="Tất cả hợp đồng đang vay" className="mr-2 mb-2 flex-1 min-w-[150px]" style={{ width: 180 }} onChange={handleSelectChange}>
                    <Option value="0">Tất cả hợp đồng đang vay</Option>
                    <Option value="1">Hợp đồng đúng hẹn</Option>
                    <Option value="2">Hợp đồng quá hạn</Option>
                    <Option value="3">Hợp đồng chậm lãi</Option>
                    <Option value="500">Hợp đồng đã kết thúc</Option>
                    <Option value="501">Hợp đồng đã xóa</Option>
                </Select>
                <Button type="primary" className="mr-2 mb-2" onClick={handleSearch}>Tìm kiếm</Button>
            </div>
            {loading ?
                (<Skeleton active />) :

                (<Table
                    className="custom-table"
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.ID}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data.length, // Tổng số dòng dữ liệu
                        onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setPageSize(pageSize);
                        },
                        showSizeChanger: true, // Hiển thị tùy chọn thay đổi số dòng
                        pageSizeOptions: [10, 20, 50, 100], // Các tùy chọn số dòng
                    }}

                    scroll={{ x: 'max-content' }} // Enable horizontal scrolling when content exceeds container width
                // summary={() => (
                //     <Table.Summary.Row>
                //         <Table.Summary.Cell index={0} colSpan={4} className="font-bold">Tổng Tiền</Table.Summary.Cell>
                //         <Table.Summary.Cell index={1} className="text-red-500">{summaryData.TOTAL_MONEY.toLocaleString('vi-VN')}</Table.Summary.Cell>
                //         <Table.Summary.Cell index={2}>0</Table.Summary.Cell>
                //         <Table.Summary.Cell index={3} className="text-red-500">{summaryData.INTEREST_MONEY_RECEIVED.toLocaleString('vi-VN')}</Table.Summary.Cell>
                //         <Table.Summary.Cell index={4}>0</Table.Summary.Cell>
                //         <Table.Summary.Cell index={5} colSpan={4} className="text-red-500">{summaryData.INTEREST_TODAY.toLocaleString('vi-VN')}</Table.Summary.Cell>
                //     </Table.Summary.Row>
                // )}
                />)}



            <CustomModalMenu isOpen={isOpenTabMenu} onClose={() => setOpenTabMenu(false)}>
                {<TabCpn tab={modalContent.tab} id={modalContent.id} />}
            </CustomModalMenu>

            <CustomModal isOpen={isAddContract} onClose={handleCloseModal}>
                {<FrmAddContract />}
            </CustomModal>

            <CustomModal isOpen={isUpdateContract} onClose={() => setIsUpdateContract(false)}>
                {<FrmUpdateContract id={modalContent.id} />}
            </CustomModal>

            {/* <CustomModal isOpen={isDeleteContract} onClose={() => setIsDeleteContract(false)}>
                {<DeleteConfirmationModal contractId={modalContent.id} />}
            </CustomModal> */}

            <Modal
                title={
                    <div>
                        <ExclamationCircleOutlined style={{ color: '#FAAD14', fontSize: '24px' }} />
                        <span style={{ marginLeft: '8px' }}>Xóa hợp đồng</span>
                    </div>
                }
                visible={isDeleteContract}
                onOk={() => handleOk(modalContent.id)}
                onCancel={() => setIsDeleteContract(false)}
                okText="Đồng ý xóa!"
                cancelText="Nghĩ lại"
                okButtonProps={{ type: 'primary', danger: true }}
            >
                <p>Bạn có chắc chắn xóa hợp đồng <strong>{modalContent.id}</strong> không?</p>
                <p>Bạn sẽ không thể khôi phục hợp đồng này nữa!</p>
            </Modal>

        </div>
    );
};

export default MenuTinChap;
